<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col>
            <h1>
              <v-btn color="primary" x-small text @click="goBack">
                <v-icon left> fa fa-angle-left </v-icon>
              </v-btn>
              Aulas
            </h1>
          </v-col>
        </v-row>
        <v-card v-if="gestaoDeAula">
          <v-row>
            <v-col cols="4">
              <v-card-text>
                <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
                <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
                <h4>
                  Carga horária:
                  {{
                    gestaoDeAula.carga_horaria
                      ? gestaoDeAula.carga_horaria
                      : "[ SEM CARGA HORÁRIA ]"
                  }}
                </h4>
                <h4>Professor: {{ gestaoDeAula.professor.nome }}</h4>
              </v-card-text>
              <v-col cols="6" class="py-2">
                <v-btn-toggle borderless>
                  <v-btn value="left" @click="() => openModalMonth(1)">
                    <span class="hidden-sm-and-down">Frequência</span>
                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn value="center" @click="() => openModalMonth(2)">
                    <span class="hidden-sm-and-down">Aulas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="curso(gestaoDeAula) != 10"
                    value="right"
                    @click="
                      () =>
                        gestaoDeAula.turma.ano_antes_de_2025 ? openModalMonth(3) : fichaNotas()
                    "
                  >
                    <span class="hidden-sm-and-down">Notas</span>

                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="curso(gestaoDeAula) === 10"
                    value="right"
                    @click="() => RelatorioBNCCTurma()"
                  >
                    <span class="hidden-sm-and-down">Relatório BNCC</span>
                    <v-icon right> mdi-file-pdf </v-icon>
                  </v-btn>

                  <v-btn value="right" @click="() => verHistoricoAulas()">
                    <span class="hidden-sm-and-down">Histórico de aulas</span>

                    <v-icon right> mdi-poll </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-col>
            <v-col cols="8" class="d-flex justify-end">
              <e-pie-aulas-lancadas :relatorio="relatorio" />
            </v-col>
          </v-row>
        </v-card>
        <v-col cols="12" class="pt-3 px-0 mt-4">
          <div class="d-flex justify-space-between">
            <v-btn
              color="success"
              :to="{
                name: 'aulas.create',
                params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
              }"
              class="mr-2"
              >Criar Aula</v-btn
            >
            <v-text-field
              v-model="search"
              class="ml-2 search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="aulasList"
          :loading="carregandoAulas"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="aula.estaDeletado ? ['deleted'] : []"
                v-for="(aula, i) in items"
                :key="aula.id"
              >
                <td>{{ aula.id }}</td>
                <td>{{ aula.data?.split("-").reverse().join("/") }}</td>
                <td width="25%">
                  <div class="d-flex align-center">
                    <e-situacao-aula :aula="aula" :i="i" @alterarSituacao="alterarSituacao" />
                    <v-chip
                      class="ml-2"
                      v-if="aula.descricaoSituacao === 'Aula em conflito'"
                      color="orange"
                      x-small
                      dark
                      @click="() => verificaSituacao(aula.id)"
                    >
                      ?</v-chip
                    >
                  </div>
                </td>
                <td><e-tipo-aula-snippet :aula="aula" /></td>
                <td>{{ aula.horario_inicial | hour }}</td>
                <td>
                  {{ aula.horario_final | hour }}
                </td>
                <td width="25%" class="text-right">
                  <v-tooltip
                    color="primary"
                    v-if="parseInt(gestaoDeAula.turma.notifiq, 10) === 1"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        :color="parseInt(aula.frequencia_notifiq, 10) === 1 ? 'primary' : 'info'"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => enableSubmit(aula)"
                      >
                        <span class="material-icons">
                          {{ parseInt(aula.frequencia_notifiq, 10) === 1 ? "link" : "link_off" }}
                        </span>
                      </v-btn>
                    </template>
                    <span>{{
                      parseInt(aula.frequencia_notifiq, 10) === 1
                        ? "Registro de presenca automático"
                        : "Registro de presenca manual"
                    }}</span>
                  </v-tooltip>
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verMotivoAula(aula)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar aula </span>
                  </v-tooltip>

                  <v-tooltip color="green darken-1" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="green darken-1"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        :loading="!!importandoPresencasAula[aula.id]"
                        :disabled="!!importandoPresencasAula[aula.id]"
                        @click="() => getPresencasHikvisionParaAula(aula)"
                      >
                        <v-icon small>mdi-bell-ring</v-icon>
                      </v-btn>
                    </template>
                    <span>Usar Notifiq (importar presenças)</span>
                  </v-tooltip>

                  <v-tooltip v-if="!aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1 white--text"
                        color="blue"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          aula.descricaoSituacao !== 'Aguardando confirmação'
                            ? !$can(['aulas.atualizarAposDefinirSituacao'])
                            : false
                        "
                        :to="{
                          name: 'aulas.frequencia',
                          params: { gestaoDeAulaId, aula_id: aula.id },
                        }"
                      >
                        <v-icon small>fa fa-thumbs-up </v-icon>
                      </v-btn>
                    </template>
                    <span>Lançar Frequência</span>
                  </v-tooltip>
                  <v-tooltip v-if="!aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          aula.descricaoSituacao !== 'Aguardando confirmação' &&
                          aula.descricaoSituacao !== 'Aula em conflito'
                            ? true
                            : false
                        "
                        @click="() => editarAula(aula)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Aula </span>
                  </v-tooltip>
                  <v-tooltip v-if="!aula.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          aula.descricaoSituacao !== 'Aguardando confirmação' &&
                          aula.descricaoSituacao !== 'Aula em conflito'
                            ? true
                            : false
                        "
                        @click="() => deletarAula(aula)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar Aula </span>
                  </v-tooltip>
                  <v-tooltip v-if="aula.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarAula(aula)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar Aula </span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <v-alert
            class="mt-2"
            style="text-align: center"
            type="orange"
            v-if="aulasConflitadas.length <= 0"
          >
            Procurando aulas em conflitos
          </v-alert>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <!-- <div style="width: 100%; text-align: left">
            <v-chip color="orange" label dark><v-icon left> mdi-label </v-icon> </v-chip>
          </div> -->

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </v-row>
    <e-drawer-motivo-aula v-model="verMotivo" :aula="aula"> </e-drawer-motivo-aula>
    <e-drawer-historico-aulas v-model="openDrawer" :gestao_id="parseInt(gestaoDeAulaId, 10)">
    </e-drawer-historico-aulas>
    <e-modal-select-month-aula
      :dialog="dialog"
      @dialogChange="dialog = $event"
      :gestao_id="gestaoDeAulaId"
      :tipo_diario="tipo_diario"
      :list="list"
    ></e-modal-select-month-aula>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="removerRegistroPeloNotifiq"
    >
    </e-modal-confirm>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  props: {
    gestaoDeAulaId: {
      required: true,
      type: [String, Number],
    },
  },
  data() {
    return {
      aulasConflitadas: [],
      aulasEmConflitos: false,
      dataTableFilter,
      aulasList: [],
      openDrawer: false,
      carregandoAulas: false,
      gestaoDeAulas: null,
      aula_notifiq: null,
      confirmDialog: false,
      objectModal: {
        title: "Notifiq",
        message:
          "Essa aula está sendo rigistrada automaticamente pelo notifiq, deseja realmente deixar esse registro manual?",
      },
      verMotivo: false,
      dialog: false,
      tipo_diario: 0,
      aula: {},
      gestaoDeAula: null,
      list: [],
      search: "",
      relatorio: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Data", value: "data_formatada" },
          { text: "Situação", value: "situacao" },
          { text: "Tipo", value: "tipo" },
          { text: "Início", value: "horario_inicial" },
          { text: "Fim", value: "horario_final" },
          { text: "Ações", value: "actions", sortable: false, width: "200px" },
        ],
      },
      importandoPresencasAula: {},
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  watch: {
    tipo_diario(value) {
      this.list = value !== 3 ? this.$constants.meses : this.$constants.bimestresRendimentos;
    },
  },
  methods: {
    async getPresencasHikvisionParaAula(aulaItem) {
      this.$set(this.importandoPresencasAula, aulaItem.id, true);
      this.$loaderService.open("Importando presenças do Hikvision...");

      try {
        const aulaComRelacoes = await this.$services.aulasService.getAulaComRelacoes(aulaItem.id);

        const date = aulaComRelacoes.data || aulaComRelacoes.data_formatada || null;
        const horario_id =
          aulaComRelacoes.horario_id ||
          (aulaComRelacoes.horario && aulaComRelacoes.horario.id) ||
          null;
        const turma_id =
          aulaComRelacoes.turma && aulaComRelacoes.turma.id ? aulaComRelacoes.turma.id : null;

        if (!date || !horario_id || !turma_id) {
          this.$toast.error("A aula precisa ter data, horário e turma para usar o Notifiq.");
          return;
        }

        const presencas = aulaComRelacoes.turma.matriculas.map((matricula) => {
          const faltou =
            aulaComRelacoes.faltas.filter(
              (f) => parseInt(f.matricula_id, 10) === parseInt(matricula.id, 10)
            ).length > 0;
          return { matricula, matricula_id: matricula.id, presente: !faltou };
        });

        const response = await this.$services.presencasService.getPresencasNotifiqHikvision({
          date,
          horario_id,
          turma_id,
        });

        const data = response?.data || response;
        const candidates = data?.candidates || [];

        if (!candidates.length) {
          this.$toast.info("Nenhuma presença do Hikvision foi encontrada para este horário.");
          return;
        }

        let presentes = 0;
        let faltas = 0;
        const promises = [];

        candidates.forEach((cand) => {
          const idx = presencas.findIndex(
            (p) => parseInt(p.matricula_id, 10) === parseInt(cand.matricula_id, 10)
          );
          if (idx === -1) return;

          const presencaAtual = presencas[idx];
          const estadoAnterior = Boolean(presencaAtual.presente);
          let marcarPresente = estadoAnterior;

          if (cand.status === "present") marcarPresente = true;
          else if (cand.status === "no_event") marcarPresente = false;

          if (marcarPresente) presentes += 1;
          else faltas += 1;

          if (estadoAnterior !== marcarPresente) {
            const presencaAtualizada = { ...presencaAtual, presente: marcarPresente };
            presencas[idx] = presencaAtualizada;
            promises.push(
              this.$services.aulasService.registrarPresenca(aulaComRelacoes, presencaAtualizada)
            );
          }
        });

        if (promises.length) await Promise.all(promises);

        this.$toast.success(
          `Notifiq aplicado: ${presentes} presentes, ${faltas} faltas e ${promises.length} alterações salvas.`
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$set(this.importandoPresencasAula, aulaItem.id, false);
        this.$loaderService.close();
      }
    },
    curso(gestao) {
      const turma = gestao.turma || null;
      return turma.curso ? turma.curso.id : null;
    },
    enableSubmit(aula = null) {
      this.confirmDialog = !this.confirmDialog;
      if (aula) {
        this.aula_notifiq = {
          ...aula,
          frequencia_notifiq: parseInt(aula.frequencia_notifiq, 10) === 1 ? 0 : 1,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
        };
        return;
      }
      this.aula_notifiq = aula;
    },
    goBack() {
      this.$router.push({ name: "gestoesDeAulas" });
    },
    async removerRegistroPeloNotifiq() {
      this.$loaderService.open("Carregando relátorio");
      try {
        if (this.aula_notifiq) {
          await this.$services.aulasService.atualizarRegistroNotifiq(this.aula_notifiq);
          this.loadData();
          // this.$set(this.aulasList, this.index_aula_notifiq, this.aula_notifiq);
        }
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.confirmDialog = !this.confirmDialog;
      this.$loaderService.close();
    },
    openModalMonth(tipo_diario) {
      this.dialog = true;
      this.tipo_diario = parseInt(tipo_diario, 10);
    },
    async diarioNotas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioNotas(this.gestaoDeAulaId);
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async RelatorioBNCCTurma() {
      try {
        this.$loaderService.open("Carregando relátorio");
        await this.$services.relatoriosService.relatorioBNCCTurma(
          parseInt(this.gestaoDeAula.turma.id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
    },
    async fichaNotas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.fichaNotas(
          parseInt(this.gestaoDeAulaId, 10),
          undefined
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.selectMonth = null;
        this.$loaderService.close();
      }
    },
    verMotivoAula(aula) {
      this.verMotivo = !this.verMotivo;
      this.aula = aula;
    },
    editarAula(aula) {
      this.$router.push({
        name: "aulas.edit",
        params: { aula_id: aula.id },
      });
    },
    alterarSituacao(Objeto) {
      this.$set(this.aulasList, Objeto.i, Objeto.aulaAtualizada);
    },
    async verificaSituacao(aula_id) {
      this.aulasEmConflitos = !this.aulasEmConflitos;
      const data = await this.$services.aulasService.listarAulasEmConflitos(aula_id);
      this.aulasConflitadas = data.data;
    },
    async loadData() {
      this.carregandoAulas = true;
      this.$loaderService.open("Carregando Aulas");
      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.gestaoDeAulaId
        );
        this.aulasList = response.aulas;
        this.gestaoDeAula = response.gestaoDeAula;
        this.relatorio = response.relatorio;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.carregandoAulas = false;
    },
    async deletarAula(aula) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Aula");
              try {
                await this.$services.aulasService.deletar(aula);
                this.aulasList = this.aulasList.filter((item) => item.id !== aula.id);
                this.$toast.success("Aula deletada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    recuperarAula(aula) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta aula?",
        confirmationCode: aula.id,
        confirmationMessage: `Por favor, digite <strong>${aula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Aula");
              try {
                await this.$services.aulasService.recuperarAula(aula);
                this.$toast.success("Aula recuperada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    async verHistoricoAulas() {
      this.openDrawer = !this.openDrawer;
    },
  },
};
</script>

<style></style>
